import { useCallback, useEffect, useState } from "react";
import { storage } from "@/lib/storage";

const KEY = "atlas.hiddenAuthors";
const EVENT = "atlas:hidden";
const read = () => { const v = storage.getJSON(KEY, []); return Array.isArray(v) ? v : []; };

/** Authors hidden on this device (Play UGC "block" requirement): [author.key]. */
export function useHiddenAuthors() {
  const [hidden, setHidden] = useState(read);
  useEffect(() => {
    const sync = () => setHidden(read());
    window.addEventListener(EVENT, sync); window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);
  const hide = useCallback((key) => { if (!key) return; storage.setJSON(KEY, [...new Set([...read(), key])]); window.dispatchEvent(new Event(EVENT)); }, []);
  const unhideAll = useCallback(() => { storage.setJSON(KEY, []); window.dispatchEvent(new Event(EVENT)); }, []);
  const filter = useCallback((items) => items.filter((r) => !hidden.includes(r.author?.key)), [hidden]);
  return { hidden, hide, unhideAll, filter };
}
